import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { selectActiveStudents } from 'modules/students/ducks/selectors'
import StudentsTable from 'modules/students/components/StudentsTable'
import ExpandablePanel from 'components/ExpandablePanel'
import { getActiveStudentsRoutine } from 'modules/students/ducks/actions'

const StudentsNoPayments = () => {
  const dispatch = useDispatch()
  const activeStudents = useSelector(selectActiveStudents)
  const studentsNoPayments = activeStudents.filter(student => student.singleLessonStudent === true)

  useEffect(() => {
    dispatch(getActiveStudentsRoutine())
  }, [])

  return (
    <div>
      <PageHeader>Uczniowie bez wpłat</PageHeader>
      <ExpandablePanel startOpen title='Lista uczniów'>
        <StudentsTable
          studentsList={studentsNoPayments}
          showSearch
        />
      </ExpandablePanel>
    </div>
  )
}

export default StudentsNoPayments

const PageHeader = styled.div`
  font-size: 24px;
  margin-bottom: 20px;
`
